module.exports = __webpack_public_path__ + "static/media/profile-details.a4026a04.svg";